/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Register_BtnInputs */



/**
* | output |
* | --- |
* | "Register App" |
*
* @param {Developer_Register_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_register_btn = /** @type {((inputs?: Developer_Register_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Register_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer une app")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar aplicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar App")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra App")
	return /** @type {LocalizedString} */ ("Register App")
});